"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerTextInputStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _textinput = require("../../../textinput");
const DatePickerTextInputStyled = (0, _styled.default)(_textinput.TextInput)`
    z-index: 0;
    position: relative;
    // overrides padding from the TextInputRootBox
    padding-right: 0px;
    &.compact-dp-input {
        width: 138px;
    }

    &:not(.compact-dp-input) {
        min-width: 138px;
    }
`;
exports.DatePickerTextInputStyled = DatePickerTextInputStyled;
//# sourceMappingURL=DatePickerTextInputStyled.js.map